module.exports = __webpack_public_path__ + "static/media/logo.c12df0fd.png";